import type { ReceiptTemplate } from '../schema';

export const fedexTemplate: ReceiptTemplate = {
  id: 'fedex',
  name: 'FedEx Receipt',
  brand: 'FEDEX',
  description: 'Shipping and delivery receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'fedex-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/fedex.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'Store #0127',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fedex-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Transaction: 847291-0127\nDate: 01/04/2026  Time: 10:23:41\nAssociate: MIKE W.',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'fedex-tracking',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '*** SHIPMENT DETAILS ***\nTracking #: 7847 2910 1274 8291',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'fedex-ship-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Service: FedEx Ground\nWeight: 2.4 lbs\nDimensions: 12x8x6 in\nZone: 5\n\nShip To:\nJames Sullivan\n500 Scare Floor Blvd\nSan Francisco, CA 94102',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'fedex-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'fedex-shipping', label: 'Shipping', value: '12.45', isBold: false, isLarge: false },
          { id: 'fedex-packaging', label: 'Packaging', value: '3.50', isBold: false, isLarge: false },
          { id: 'fedex-insurance', label: 'Insurance', value: '2.99', isBold: false, isLarge: false },
          { id: 'fedex-tax', label: 'Tax', value: '1.68', isBold: false, isLarge: false },
          { id: 'fedex-total', label: 'TOTAL', value: '20.62', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'fedex-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'fedex-card', label: 'VISA', value: '************4144' },
          { id: 'fedex-auth', label: 'Auth', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'fedex-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '784729101274',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fedex-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Track your package at\nfedex.com/tracking\n\nThank you for choosing FedEx!',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

